import { Routes } from '@angular/router';
import { appRoutePaths, appRouteSegments } from './app.paths';
import { FinzzleAuthRedirect, finzzleAuthGuard } from '@finzzle/auth';
import { DuplicatedArianePageComponent } from './features/applications/atlas/doublons-ariane/doublons-ariane.component';
import { DuplicatedPersonnePhysiquePageComponent } from './features/applications/atlas/doublons-personne-physique/doublons-personne-physique.component';
import { ArianeDuplicateInspectionPageComponent } from './features/applications/atlas/ariane-duplicate-inspection/ariane-duplicate-inspection.component';
import { AtlasConsultantSearchPageComponent } from './features/applications/atlas/consultant-search/consultant-search.component';
import { ConsultantInspectionPageComponent } from './features/applications/atlas/consultant-inspection/consultant-inspection.component';
import { AtlasBouquetServicePageComponent } from './features/applications/atlas/bouquet-service/bouquet-service.component';
import { InvestorInspectionPageComponent } from './features/applications/atlas/investor-inspection/investor-inspection.component';
import { AtlasInvestorSearchPageComponent } from './features/applications/atlas/viewer/atlas-viewer.component';
import { CrossConsultantRelationsPageComponent } from './features/applications/atlas/cross-consultant-relations/cross-consultant-relations.component';
import { AuthComponent } from './features/auth/auth.component';
import { BatchWorkspaceComponent } from './features/applications/minotaure/batch-workspace/batch-workspace.component';
import { MetadataWorkspaceComponent } from './features/applications/minotaure/metadata-workspace/metadata-workspace.component';
import { RecueilCrossConsultantPageComponent } from './features/applications/minotaure/recueil-cross-consultant/recueil-cross-consultant.component';
import { ReportingDashboardComponent } from './features/applications/minotaure/reporting-dashboard/reporting-dashboard.component';
import { TechnicalCachesPageComponent } from './features/applications/technical/caches/technical-caches.component';
import { TechnicalInvestorPurgeExecutionsPageComponent } from './features/applications/technical/investor-purge-executions/technical-investor-purge-executions.component';
import { AprilAdiIntegrationPageComponent } from './features/applications/aramis/april-adi-integration/april-adi-integration.component';
import { CoutsExPostPageComponent } from './features/applications/controle-gestion/couts-ex-post/couts-ex-post.component';
import { CoutsExPostCampaignDetailPageComponent } from './features/applications/controle-gestion/couts-ex-post/couts-ex-post-campaign-detail.component';
import { ProxeemaInvestorSignaturesPageComponent } from './features/applications/proxeema/investor-signatures/proxeema-investor-signatures.component';
import { ProxeemaUniversignTransactionsPageComponent } from './features/applications/proxeema/universign-transactions/proxeema-universign-transactions.component';
import { ProxeemaSignatureAnomaliesPageComponent } from './features/applications/proxeema/signature-anomalies/proxeema-signature-anomalies.component';

export const appRoutes: Routes = [
  // Pont de retour MSAL : doit rester sans guard et avant le catch-all.
  {
    path: `${appRouteSegments.auth}/redirect`,
    component: FinzzleAuthRedirect
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: appRoutePaths.home
  },
  {
    path: appRouteSegments.auth,
    component: AuthComponent,
    title: 'Authentification'
  },
  {
    path: appRouteSegments.applications,
    canActivate: [finzzleAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: `${appRouteSegments.minotaure}/${appRouteSegments.reporting}`
      },
      {
        path: appRouteSegments.atlas,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.rechercheInvestisseur
          },
          {
            path: appRouteSegments.rechercheInvestisseur,
            component: AtlasInvestorSearchPageComponent,
            title: 'Recherche investisseur Atlas'
          },
          {
            path: appRouteSegments.rechercheConsultant,
            component: AtlasConsultantSearchPageComponent,
            title: 'Recherche consultant Atlas'
          },
          {
            path: appRouteSegments.doublonsAriane,
            component: DuplicatedArianePageComponent,
            title: 'Doublons Ariane'
          },
          {
            path: appRouteSegments.doublonsPersonnePhysique,
            component: DuplicatedPersonnePhysiquePageComponent,
            title: 'Doublons personne physique'
          },
          {
            path: appRouteSegments.relationsInterConsultants,
            component: CrossConsultantRelationsPageComponent,
            title: 'Relations inter-consultants'
          },
          {
            path: appRouteSegments.bouquetService,
            component: AtlasBouquetServicePageComponent,
            title: 'Bouquet de service'
          },
          {
            path: `${appRouteSegments.doublonsAriane}/:arianeId`,
            component: ArianeDuplicateInspectionPageComponent,
            title: 'Inspection doublon Ariane'
          },
          {
            path: `${appRouteSegments.investors}/:investorId`,
            component: InvestorInspectionPageComponent,
            title: 'Inspection investisseur'
          },
          {
            path: `${appRouteSegments.consultants}/:consultantId`,
            component: ConsultantInspectionPageComponent,
            title: 'Inspection consultant'
          }
        ]
      },
      {
        path: appRouteSegments.minotaure,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.reporting
          },
          {
            path: appRouteSegments.reporting,
            component: ReportingDashboardComponent,
            title: 'Reporting Minotaure'
          },
          {
            path: appRouteSegments.recueilInterConsultants,
            component: RecueilCrossConsultantPageComponent,
            title: 'Recueil inter-consultants'
          },
          {
            path: appRouteSegments.batch,
            component: BatchWorkspaceComponent,
            title: 'Batch Minotaure'
          },
          {
            path: `${appRouteSegments.metadata}/:metadataId`,
            component: MetadataWorkspaceComponent,
            title: 'Workspace metadata'
          }
        ]
      },
      {
        path: appRouteSegments.technical,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.caches
          },
          {
            path: appRouteSegments.caches,
            component: TechnicalCachesPageComponent,
            title: 'Technique - Caches'
          },
          {
            path: appRouteSegments.purgeJobs,
            component: TechnicalInvestorPurgeExecutionsPageComponent,
            title: 'Technique - Demandes de purge'
          }
        ]
      },
      {
        path: appRouteSegments.aramis,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.integrationApril
          },
          {
            path: appRouteSegments.integrationApril,
            component: AprilAdiIntegrationPageComponent,
            title: 'Aramis - Intégration APRIL'
          }
        ]
      },
      {
        path: appRouteSegments.controleGestion,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.coutsExPost
          },
          {
            path: appRouteSegments.coutsExPost,
            component: CoutsExPostPageComponent,
            title: 'Coûts ex-post'
          },
          {
            path: `${appRouteSegments.coutsExPost}/:campaignId`,
            component: CoutsExPostCampaignDetailPageComponent,
            title: 'Campagne coûts ex-post'
          }
        ]
      },
      {
        path: appRouteSegments.proxeema,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: appRouteSegments.signaturesInvestisseur
          },
          {
            path: appRouteSegments.signaturesInvestisseur,
            component: ProxeemaInvestorSignaturesPageComponent,
            title: 'Proxeema - Signatures investisseur'
          },
          {
            path: `${appRouteSegments.signaturesInvestisseur}/:investorId`,
            component: ProxeemaInvestorSignaturesPageComponent,
            title: 'Proxeema - Signatures investisseur'
          },
          {
            path: appRouteSegments.transactionsUniversign,
            component: ProxeemaUniversignTransactionsPageComponent,
            title: 'Proxeema - Transactions Universign'
          },
          {
            path: appRouteSegments.anomaliesSignatures,
            component: ProxeemaSignatureAnomaliesPageComponent,
            title: 'Proxeema - Anomalies de signature'
          }
        ]
      }
    ]
  },
  {
    path: appRoutePaths.legacy.report.slice(1),
    pathMatch: 'full',
    redirectTo: appRoutePaths.minotaure.reporting
  },
  {
    path: appRoutePaths.legacy.batch.slice(1),
    pathMatch: 'full',
    redirectTo: appRoutePaths.minotaure.batch
  },
  {
    path: `${appRoutePaths.legacy.metadata(':metadataId').slice(1)}`,
    pathMatch: 'full',
    redirectTo: `${appRoutePaths.minotaure.root}/${appRouteSegments.metadata}/:metadataId`
  },
  {
    path: '**',
    redirectTo: appRoutePaths.home
  }
];
